import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  width: {
    width: '100%',
  },
  spacing: {
    marginBottom: theme.spacing(2),
  },
}));

/**
 *
 * @param {objects} array selectable items, in the format of [{display_name: 'Object', scope: 'object'}, etc...]
 * @param {selectedObjects} array stateful string array that holds the selected objects
 * @param {setSelectedObjects} func the function that sets selectedObjects
 * @param {title} string the title
 */

const DropdownCheckbox = ({ objects, selectedObjects, setSelectedObjects, title }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChange = (event, object) => {
    if (event.target.checked) {
      setSelectedObjects([...selectedObjects, object.scope]);
    } else {
      setSelectedObjects(selectedObjects.filter((selectedObject) => selectedObject !== object.scope));
    }
  };

  return (
    <FormControl className={classes.width} variant="standard">
      <FormLabel className={classes.spacing}>{t(title)}</FormLabel>
      <Select
        multiple
        value={selectedObjects}
        input={<OutlinedInput />}
        renderValue={(selected) => selected.map((x) => x).join(', ')}
      >
        {objects.map((object) => (
          <Box key={object.scope}>
            <MenuItem value={object.scope}>
              <Checkbox
                checked={selectedObjects?.some((selectedObject) => selectedObject === object.scope)}
                onClick={(event) => handleChange(event, object)}
              />
              <ListItemText primary={object.display_name} />
            </MenuItem>
          </Box>
        ))}
      </Select>
    </FormControl>
  );
};

DropdownCheckbox.propTypes = {
  objects: PropTypes.array,
  selectedObjects: PropTypes.array,
  setSelectedObjects: PropTypes.func.isRequired,
  title: PropTypes.string,
};

DropdownCheckbox.defaultProps = {
  objects: [],
  selectedObjects: [],
  title: '',
};

export default DropdownCheckbox;
